// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".glide__bullet{width:12px;height:12px;border-width:1px}.glide__slide{height:auto !important}@media (max-width: 500px){.toastify{max-width:90% !important;text-align:center !important}}\n", ""]);
// Exports
module.exports = exports;
